import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

export class PreinvoiceFormFactory {
    static buildForm(fb: UntypedFormBuilder): UntypedFormGroup {
        return fb.group({
            uid: [null],

            contactUid: [null, Validators.required],
            preInvoiceNumber: [''],

            invoiceRelease: [new Date(), Validators.required],
            invoiceExpiration: [new Date(), Validators.required],
            centerUid: [null],

            applyKm: [false],
            numberKilometers: [null],

            applyDiscount: [false],
            isMeasurable: [false],

            applyProject: [false],

            items: fb.array([]),

            payMethodUid: [null, Validators.required],
            bankAccountUid: [null],
            cashRegisterUid: [null],
            partnerUid: [null],

            useDeliverAddress: [false],
            deliverAddress: [null],

            projectUid: [null],
            entranceAccount: [null, Validators.required],

            comments: [''],

            issuerAddress: [''],
            issuerPostalCode: [''],
            issuerLocation: [''],
            issuerCountry: [''],
            issuerState: [''],
            issuerName: [''],
            issuerVatNumber: [''],
        });
    }

    static items(form: UntypedFormGroup): UntypedFormArray {
        return form.get('items') as UntypedFormArray;
    }

    static createTitle(fb: UntypedFormBuilder): UntypedFormGroup {
        return fb.group({
            type: ['title'],
            title: ['']
        });
    }

    static createLine(fb: UntypedFormBuilder): UntypedFormGroup {
        return fb.group({
            type: ['line'],
            id: [0],
            serieConceptUid: [null],
            conceptUid: [null, Validators.required],

            masterUnitMeasurableUid: [null],
            quantityMeasurable: [1],

            quantity: [1, Validators.required],
            price: [0, Validators.required],
            discount: [0],
            tax: [[]]
        });
    }

    // -----------------------------
    // MENSAJES DESCRIPTIVOS
    // -----------------------------

    static getValidationMessages(form: UntypedFormGroup): string[] {
        const messages: string[] = [];

        // 1) Mensajes del form raíz
        this.pushIfRequired(messages, form, 'contactUid', 'Selecciona un contacto.');
        this.pushIfRequired(messages, form, 'invoiceRelease', 'Indica la fecha de creación.');
        this.pushIfRequired(messages, form, 'invoiceExpiration', 'Indica la fecha de expiración.');
        this.pushIfRequired(messages, form, 'payMethodUid', 'Selecciona el tipo de cobro.');
        this.pushIfRequired(messages, form, 'bankAccountUid', 'Selecciona la cuenta bancaria.');
        this.pushIfRequired(messages, form, 'cashRegisterUid', 'Selecciona la caja.');
        this.pushIfRequired(messages, form, 'partnerUid', 'Selecciona el socio.');
        this.pushIfRequired(messages, form, 'entranceAccount', 'Selecciona la cuenta contable de ingreso.');

        // 2) Mensajes de items (solo las líneas type="line")
        const items = form.get('items') as UntypedFormArray;
        if (items && items.length) {
            for (let i = 0; i < items.length; i++) {
                const g = items.at(i) as UntypedFormGroup;
                const typeCtrl = g.get('type');
                const type = typeCtrl ? typeCtrl.value : null;

                if (type !== 'line') continue;

                const lineNumber = i + 1;

                // conceptUid
                if (this.isRequiredMissing(g.get('conceptUid'))) {
                    messages.push(`Línea ${lineNumber}: selecciona un concepto.`);
                }

                // quantity
                if (this.isRequiredMissing(g.get('quantity'))) {
                    messages.push(`Línea ${lineNumber}: indica la cantidad.`);
                }

                // price
                if (this.isRequiredMissing(g.get('price'))) {
                    messages.push(`Línea ${lineNumber}: indica el precio.`);
                }
            }
        }

        // 3) (Opcional) si no hay líneas y queréis exigir al menos una
        // if (!items || items.length === 0) messages.push('Añade al menos una línea a la pre-factura.');

        return this.unique(messages);
    }

    // Helpers (sin ?, sin Set)
    private static pushIfRequired(out: string[], form: UntypedFormGroup, key: string, msg: string): void {
        const ctrl = form.get(key);
        if (this.isRequiredMissing(ctrl)) out.push(msg);
    }

    private static isRequiredMissing(ctrl: AbstractControl): boolean {
        if (!ctrl) return false;
        const errors = ctrl.errors;
        return !!(errors && errors.required);
    }

    private static unique(arr: string[]): string[] {
        // dedupe sin Set para Angular/TS antiguos
        return arr.filter((v, i, a) => a.indexOf(v) === i);
    }
}
